import React, { useState } from 'react';
import 'uikit/dist/css/uikit.css';
import "../scss/components/quote-carousel.scss";
import UIkit from 'uikit';
import StarGroupImg from "../assets/img/star_group.png"


const QuoteCarousel = ({quoteList, title, description, sectionStyle="dark"}) => {
 
    const [modalData, setModalData] = useState(null); // Store selected card details
 
    const handleCardClick = (card) => {
      setModalData(card); // Set modal data to the clicked card
      UIkit.modal('#card-modal').show(); // Show the modal
    };

    const sectionClassName = sectionStyle =="white" ? "white-section" : "dark-section";
  
    return(
        <section className={sectionClassName + " quote-carousel padding-top padding-bottom"}>
          
          <div className="carousel-section-wrapper">
              {
                title ? <h2>{title}</h2>
                      : ''
              }
              
              {
                description ? <p>{description}</p>
                            : ''
              }

            <div className="custom-slider-container" data-uk-slider>

              <div className="testimonials-width uk-position-relative uk-visible-toggle uk-dark custom-slider" tabIndex="-1">
          
                  <ul className="uk-slider-items 
                      uk-child-width-1-1@xs 
                      uk-child-width-1-2@s 
                      uk-child-width-1-3@m 
                      uk-child-width-1-4@l
                      uk-child-width-1-6@xl 
                      uk-grid carousel-container">

                      {quoteList.map((item, index) => {
                        
                        return(
                          <li key={index}>
                              <div className="uk-padding-none uk-text-left uk-card">
                                  
                                  <div className="uk-card-body " 
                                  onClick={() => handleCardClick(item)} // Handle card click
                                  style={{ cursor: 'pointer' }}
                                  >
                                    <div className='star-rating'>
                                       <img src={StarGroupImg} alt="Rating Image" />
                                    </div>
                                    <div className="message">
                                      <div className="message-text">"{item.Message}"</div>
                                    </div>
                                      
                                    <div className="uk-card-title">{item.Author}</div>
                                  </div>
                              </div>
                          </li>
                        )
                      })}

                    
                      
                  </ul>

                  {/* <button className="uk-position-center-left uk-hidden-hover" href="#0" data-uk-slidenav-previous data-uk-slider-item="previous" aria-label="previous"></button>
                  <button className="uk-position-center-right uk-hidden-hover" href="#0" data-uk-slidenav-next data-uk-slider-item="next" aria-label="next"></button> */}

              </div>
              <a className="uk-position-center-left  slider-nav prev" href="#" data-uk-slidenav-previous data-uk-slider-item="previous">
                  <svg width="25" height="50" viewBox="0 0 25 50" xmlns="http://www.w3.org/2000/svg">
                      <polyline fill="none" stroke="#000" stroke-width="2" points="20.527,-10 2,20.024 20.525,50 "></polyline>
                  </svg>
              </a>
              <a className="uk-position-center-right  slider-nav next" href="#" data-uk-slidenav-next data-uk-slider-item="next">
                  <svg width="25" height="50" viewBox="0 0 25 50" xmlns="http://www.w3.org/2000/svg">
                      <polyline fill="none" stroke="#000" stroke-width="2" points="4.002,50 20.527,20.024 4,-10 "></polyline>
                  </svg>
              </a>

              {/* <ul className="uk-slider-nav uk-dotnav uk-flex-center uk-margin"></ul> */}

            </div>
          </div>
          
          <div id="card-modal" className="uk-flex-top uk-modal" uk-modal>
            <div className="uk-modal-dialog uk-modal-body ">

                  {/* <button class="uk-modal-close-default" type="button" uk-close></button> */}

                  {modalData ? (
                    <div>
                      <p>"{modalData.Message}"</p>
                      <div className="card-modal-title">{modalData.Author}</div>
                    </div>
                  ) : (
                    <p>Loading...</p>
                  )}

                  <div className="uk-text-right">
                      <button className="uk-button uk-button-default uk-modal-close" type="button">Close</button>
                  </div>
              </div>
          </div>

        </section>
    )

}

export default QuoteCarousel